import { compose, withProps } from 'recompose';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { withTheme } from 'styled-components';

import { unreadMessages } from 'ggApp/modules/intercom';
import { location as locationSelector } from 'ggApp/modules/router/selectors';
import { newDashboardFeatureFlag as newDashboardFeatureFlagSelector } from 'ggApp/modules/featureFlag/selectors';
import { storeActive as activeStoreSelector } from 'ggApp/modules/store/selectors';
import {
    userCompany as userCompanySelector,
    user as userSelector,
    isIncompleteBusinessAccount as isIncompleteBusinessAccountSelector,
} from 'ggApp/modules/auth/selectors';
import { initDone as initDoneSelector } from 'ggApp/modules/init/selectors';

import LoggedInControls from './LoggedInControls';

const enhance = compose(
    connect(
        createStructuredSelector({
            activeStore: activeStoreSelector,
            unreadMessages,
            location: locationSelector,
            dashboardFeatureFlag: newDashboardFeatureFlagSelector,
            company: userCompanySelector,
            user: userSelector,
            isIncompleteBusinessAccount: isIncompleteBusinessAccountSelector,
            initDone: initDoneSelector,
        }),
    ),
    withProps(({ activeStore: { code, store_id: storeId } }) => ({
        storeCode: code,
        storeId,
    })),
    withTheme,
);

export default enhance(LoggedInControls);
